import * as _ from "lodash";
import ReactDOM from "react-dom";
import React from "react";

import StatusChart from "./statusChart";

export class StatusPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        super((viewer.container as HTMLElement), "SmartDrawings-Panel-Status", "Status", null);
        this.viewer = viewer;

        this.container.classList.add("status-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);
    }

    setVisible(show: boolean) {
        super.setVisible(show);
        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<StatusChart viewer={this.viewer} />, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }

}